// extracted by mini-css-extract-plugin
module.exports = {"coverContainer":"cover_coverContainer__1mEmm","bg":"cover_bg__F49SG","heading1":"cover_heading1__38lZu","span":"cover_span__eQPS0"};